import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { ModalBody, ModalFooter, Modal, Button, Label } from 'reactstrap';
import { formatToLocaleDate } from '../../helpers/dateUtils';
import 'react-datepicker/dist/react-datepicker.css';
import '../../helpers/datePickerConfig';

const ModalDate = (props) => {
  const handleFecha = (value) => {
    if (!value) {
      props.setFecha('');
      return;
    }
    const formattedDate = formatToLocaleDate(value);
    props.setFecha(formattedDate);
  };

  const handleFechaFinal = (value) => {
    if (!value) {
      props.setFechaFinal('');
      return;
    }
    const formattedDate = formatToLocaleDate(value);
    props.setFechaFinal(formattedDate);
  };

  const parseInitialDate = (dateString) => {
    if (!dateString || dateString === '') return null;
    const parts = dateString.split('/');
    if (parts.length === 3) {
      return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    }
    return null;
  };

  return (
    <Modal isOpen={props.state} centered>
      <ModalBody>
        <Label htmlFor="dateCreate">
          <b>Seleccionar fecha inicial</b>
        </Label>
        <DatePicker
          selected={parseInitialDate(props.fecha)}
          onChange={handleFecha}
          dateFormat="dd/MM/yyyy"
          locale="es"
          className="form-control"
        />

        <Label htmlFor="dateCreate" className="mt-3">
          <b>Seleccionar fecha final</b>
        </Label>
        <DatePicker
          selected={parseInitialDate(props.fechaFinal)}
          onChange={handleFechaFinal}
          dateFormat="dd/MM/yyyy"
          locale="es"
          className="form-control"
        />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={props.dateFunction}
          disabled={props.fecha === '' || props.fechaFinal === ''}
        >
          Aceptar
        </Button>
        <Button
          color="danger"
          onClick={() => {
            props.setState(false);
          }}
        >
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
ModalDate.propTypes = {
  dateFunction: PropTypes.func,
  state: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setState: PropTypes.func,
  setFecha: PropTypes.func,
  fecha: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  setFechaFinal: PropTypes.func,
  fechaFinal: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};
export default ModalDate;
